import React, { useState } from "react";
import { Button, Label } from "reactstrap";
import { formatDate, formatRP } from "../../../Utils/externalFunctions";
import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import DataTable from "react-data-table-component";
import { Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import ConfirmRemovalModal from "../components/ConfirmRemovalModal";
import { toast } from "react-toastify";
import useAxios from "../../../Utils/useAxios";
import { timeToast } from "../../../Constant";
import { useThemeContext } from "../../../Context/ThemeContext";
import DateSortFunction from "../../DataTableComponents/DateSortFunction";
import { createGroupDokumenTransaksi } from "../services";
toast.configure();

const StepDua = ({
  formGroupTransaksi,
  updateFormGroupTransaksi,
  transaksiList,
  handleDelete,
  handlePrev,
  handleNext,
}) => {
  const axiosInstance = useAxios();
  const [selectedTransaksiToDelete, setSelectedTransaksiToDelete] =
    useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const toggleDeleteModal = () => setDeleteModalOpen(!deleteModalOpen);

  const [waitingForSubmit, setWaitingForSubmit] = useState(false);

  const { themeContext } = useThemeContext();

  const checkOnlyOneUnitKerja = (transaksiList) => {
    const id_unit_kerja = transaksiList[0].id_unit_kerja;
    const filteredTransaksi = transaksiList.filter(
      (item) => item.id_unit_kerja !== id_unit_kerja
    );
    return filteredTransaksi.length;
  };

  const checkGroupTransaksiIsEmpty = (groupTransaksi) => {
    return groupTransaksi.length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (checkGroupTransaksiIsEmpty(formGroupTransaksi.group_transaksi)) {
      toast.error("List transaksi tidak boleh kosong", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
    } else if (checkOnlyOneUnitKerja(transaksiList)) {
      toast.error("List transaksi harus memiliki DPSJ yang sama", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
    } else {
      try {
        setWaitingForSubmit(true);

        createGroupDokumenTransaksi(axiosInstance, formGroupTransaksi).then(
          (response) => {
            updateFormGroupTransaksi(response.data);
            handleNext();
            setWaitingForSubmit(false);
          }
        );
      } finally {
        setWaitingForSubmit(false);
      }
    }
  };

  const DaftarColumns = [
    {
      name: <DataTableTitle text={"Kode Transaksi"} />,
      selector: (row) => row.id_transaksi,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Diajukan Oleh"} />,
      selector: (row) => row.diajukan_oleh,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"DPSJ"} />,
      selector: (row) => row.id_unit_kerja,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Tanggal Transaksi"} />,
      selector: (row) => formatDate(row.tanggal_transaksi),
      sortable: true,
      sortFunction: DateSortFunction("tanggal_transaksi"),
    },
    {
      name: <DataTableTitle text={"Keterangan"} />,
      selector: (row) => row.keterangan,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Dibayar Ke"} />,
      selector: (row) => row.dibayarkan_ke,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Diperlukan (Rp)"} />,
      selector: (row) => parseInt(row.nilai_transaksi),
      sortable: true,
      format: (row) => formatRP(row.nilai_transaksi),
    },
    {
      // name: <DataTableTitle text={"Operasi"} />,
      cell: (row) => (
        <Link
          onClick={(e) => {
            e.preventDefault();
            toggleDeleteModal();
            setSelectedTransaksiToDelete(row);
          }}
        >
          <Trash2 color="red" />
        </Link>
      ),
    },
  ];

  return (
    <>
      <Label className="bg-transparent">Transaksi yang digrupkan</Label>
      <DataTable
        columns={DaftarColumns}
        data={transaksiList}
        pagination
        selectableRowsHighlight
        highlightOnHover
        persistTableHead
        theme={themeContext}
      />
      <div className="row justify-content-center mt-4">
        <div className="col-auto">
          <Button
            onClick={(e) => {
              handleSubmit(e);
            }}
            disabled={waitingForSubmit}
          >
            Submit
          </Button>
        </div>
        <div className="col-auto">
          <Button color="primary" variant="contained" disabled>
            Cetak
          </Button>
        </div>
      </div>
      <div className="row justify-content-between mt-4">
        <div className="col-auto">
          <Button onClick={handlePrev}>Kembali</Button>
        </div>
      </div>
      <ConfirmRemovalModal
        deleteModalOpen={deleteModalOpen}
        toggleDeleteModal={toggleDeleteModal}
        handleDelete={handleDelete}
        row={selectedTransaksiToDelete}
      />
    </>
  );
};

export default StepDua;
